<template>
  <div>
    <o-card ref="form" :title="$t('sandoz.verification')" class="ortic-form-horizontal contract-view">
      <b-row>
        <b-col>
          <o-form-group :label="$t('sandoz.contract_year')">
            <div class="form-control border-0">
              {{
                verification.contract_line && verification.contract_line.contract ? verification.contract_line.contract.contract_year : ''
              }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('sandoz.contract_no')">
            <div class="form-control border-0">
              {{
                verification.contract_line && verification.contract_line.contract ? verification.contract_line.contract.contract_no : ''
              }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('sandoz.customer_external_id')">
            <div class="form-control border-0">
              {{
                verification.contract_line && verification.contract_line.contract ? verification.contract_line.contract.customer_external_id : ''
              }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('sandoz.planned_verification')">
            <div class="form-control border-0">
              {{ verification.planned_verification | formatDatetime }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('sandoz.actual_verification')">
            <div class="form-control border-0">
              {{ verification.actual_verification | formatDatetime }}
            </div>
          </o-form-group>
        </b-col>
        <b-col>
          <o-form-group :label="$t('sandoz.product_name')">
            <div class="form-control border-0">
              {{
                verification.contract_line && verification.contract_line.product ? verification.contract_line.product.name_lang : ''
              }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('sandoz.company_name')">
            <div class="form-control border-0">
              {{
                verification.contract_line && verification.contract_line.contract_address ? verification.contract_line.contract_address.company_name : ''
              }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('core.first_name')">
            <div class="form-control border-0">
              {{ verification.user ? verification.user.first_name : '' }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('core.name')">
            <div class="form-control border-0">
              {{ verification.user ? verification.user.name : '' }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('sandoz.status')">
            <div class="form-control border-0">
              <span v-if="verification.status" :class="badge(verification.status)" class="badge">
                {{ $t('sandoz.' + verification.status.toLowerCase()) }}
              </span>
            </div>
          </o-form-group>
          <o-form-group :label="$t('core.note')">
            <div class="form-control border-0">
              {{ verification.note }}
            </div>
          </o-form-group>
        </b-col>
      </b-row>
    </o-card>
    <b-tabs v-if="pictures && pictures.length">
      <b-tab :title="$t('sandoz.pictures')" active>
        <silent-box :gallery="galleryPictures" :lazy-loading="true" ref="silentbox"></silent-box>
        <a class="silentbox-item" v-bind:key="silentboxItem.alt" v-for="(silentboxItem) in pictures">
          <o-card class="ortic-form-horizontal contract-view mr-2 mb-2 mw-242 ">
            <div
                :style="{'background-image': 'url('+silentboxItem.src + ')', 'height': silentboxItem.thumbnailHeight}"
                class="bg-image" @click="downloadFile(silentboxItem)">
            </div>
            <o-form-group :label="$t('sandoz.latitude')" class="mb-0 mt-2">
              <div class="form-control border-0">
                {{ silentboxItem.latitude }}
              </div>
            </o-form-group>
            <o-form-group :label="$t('sandoz.longitude')" class="mb-0">
              <div class="form-control border-0">
                {{ silentboxItem.longitude }}
              </div>
            </o-form-group>
            <o-form-group :label="$t('sandoz.distance')" class="mb-0">
              <div class="form-control border-0">
                {{ silentboxItem.distance | formatDistance }}
              </div>
            </o-form-group>
          </o-card>
        </a>
      </b-tab>
    </b-tabs>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button variant="outline-primary" @click.prevent="$router.push({name: 'sandoz.verifications'})">
          {{$t('core.back')}}
        </o-button>
      </div>
    </o-action-toolbar>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSilentbox from 'vue-silentbox'
import axios from 'axios'

Vue.use(VueSilentbox)

export default {
  data: () => ({
    verification: {},
    stateBadge: {},
    galleryPictures: [],
    pictures: []
  }),
  methods: {
    badge (state) {
      if (!state) {
        return
      }
      return this.stateBadge[state]
    },
    load (url) {
      var self = this
      return axios
        .get(url)
        .then((response) => {
          self.verification = response.data
          if (self.verification.pictures && self.verification.pictures.length) {
            self.verification.pictures.forEach(function (item) {
              var doc = false;
              var src = '/verifications/' + self.$route.params.id + '/' + item.picture;
              var extension = item.picture.split('.').pop().toLowerCase();
              if(extension !== 'png' && extension !== 'jpg' && extension !== 'jpeg') {
                  doc = true;
                  if(extension === 'doc' || extension === 'docx') {
                      extension = 'doc';
                  }
                  if(extension === 'xlsx' || extension === 'xls') {
                      extension = 'xls';
                  }
                  if(extension === 'html' || extension === 'eml' || extension === 'txt' || extension === 'msg') {
                    extension = 'html';
                  }
                  src = '/images/'+extension+'-icon.png'
              }
              self.pictures.push({
                src: src,
                alt: item.picture,
                thumbnailHeight: '210px',
                latitude: item.latitude,
                longitude: item.longitude,
                distance: item.distance,
                url: '/api/verifications/download/'+self.$route.params.id+'/'+item.picture,
                download: doc
              })

              if(doc === false) {
                self.galleryPictures.push({
                  src: src,
                  alt: item.picture,
                  thumbnailHeight: '210px',
                  latitude: item.latitude,
                  longitude: item.longitude,
                  distance: item.distance,
                  url: '/api/verifications/download/'+self.$route.params.id+'/'+item.picture,
                  download: doc
                })
              }
            })
          }
        })
        .catch((error) => {
          self.$notify({
            title: self.$i18n.t('core.load_error'),
            text: self.$i18n.t('core.load_error_text', { url: url }),
            type: 'error'
          })
        })
    },
    downloadFile(item) {
      if(item.download) {
        window.open(item.url, '_blank')
      } else {
        this.$refs.silentbox.openOverlay(item, 0)
      }
    }
  },
  created () {
    this.stateBadge = {
      'pending': 'badge-primary',
      'verified': 'badge-success',
      'failed': 'badge-danger'
    }
    this.load('/api/sandoz/verifications/' + this.$route.params.id + '?include=user,pictures,contract_line,contract_line.contract,contract_line.contract_address,contract_line.product,contract_line.product.productMaster')
  }
}
</script>

<style>
  #silentbox-gallery .silentbox-item {
    display: none;
  }
</style>
